/* import __COLOCATED_TEMPLATE__ from './team-availability-setting-expectation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();